class WarrantyAddon extends HTMLElement {
  constructor() {
    super();
    this.miniCart = document.querySelector('mini-cart');
    this.warrantyVariantId = this.dataset.warrantyVariantId;
    this.warrantyInCart = this.dataset.warrantyInCart === 'true';
    this.querySelector('[name="warranty-addon"]').addEventListener("change", (event) => {
      event.target.checked ? this.addWarranty() : this.removeWarranty();
    });
  }

  addWarranty() {
    const loadingOverlay = this.querySelector('.loading-overlay');
    loadingOverlay.classList.remove('hidden');
    const sections = this.getSectionsToRender().map((section) => section.section);
    const body = JSON.stringify({
      id: this.warrantyVariantId,
      quantity: 1,
      sections: sections,
      sections_url: window.location.pathname
    });
    fetch(`${theme.routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((response) => {
        loadingOverlay.classList.add('hidden');
        if (response.status) {
          this.querySelector('[name="warranty-addon"]').checked = false;
          console.error('Error adding warranty:', response.description);
          return;
        }
        if (document.body.classList.contains('template-cart')) {
          window.location.href = theme.routes.cart_url;
          return;
        }
        this.miniCart && this.miniCart.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
        loadingOverlay.classList.add('hidden');
        this.querySelector('[name="warranty-addon"]').checked = false;
      });
  }

  removeWarranty() {
    const loadingOverlay = this.querySelector('.loading-overlay');
    loadingOverlay.classList.remove('hidden');
    const sections = this.getSectionsToRender().map((section) => section.section);
    const body = JSON.stringify({
      updates: {
        [this.warrantyVariantId]: 0
      },
      sections: sections,
      sections_url: window.location.pathname
    });
    fetch(`${theme.routes.cart_update_url}`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then((response) => {
        loadingOverlay.classList.add('hidden');
        
        if (document.body.classList.contains('template-cart')) {
          window.location.href = theme.routes.cart_url;
          return;
        }
        this.miniCart && this.miniCart.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
        loadingOverlay.classList.add('hidden');
        this.querySelector('[name="warranty-addon"]').checked = true;
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('warranty-addon', WarrantyAddon);

